import {IFormEntityData} from 'modules/data/data-types';
import {IRequestData} from 'store/slices/request-slice/request-slice-type';

import {ERequestTypeCode} from '../request-form/request-form.constants';

export const convertRequestFormData = (
    requestData?: IRequestData,
    requestCommentId?: string,
    prolongationDate?: Date,
    isRequestAdditionalPlacementType?: boolean,
    numberRequest?:string,
): IFormEntityData => ({
    data: {
        topicRequestType: requestData?.requests?.topicRequestType,
        requestId: requestData?.requests?.id,
        commentType: requestData?.requests?.topicRequestType?.typeCode || requestData?.requests?.requestType,
        requests: requestData?.requests,
        commentId: requestCommentId,
        topicStatus: requestData?.requests?.topicStatus,
        prolongationDate: prolongationDate || requestData?.prolongationRequest?.prolongationDate,
        numberRequest: isRequestAdditionalPlacementType ? requestData?.requests?.numberRequest : numberRequest,
        requestAddressesType: ERequestTypeCode.REQUEST,
        responseAddressesType: ERequestTypeCode.RESPONSE,
        commentAddressesType: ERequestTypeCode.COMMENT_REQUEST,
    } || {},
    id: requestData?.requests?.id || '-1',
}) as unknown as IFormEntityData;

export const convertRequestData = (
    requestData?: IRequestData,
    data?: any,
    requestCommentId?: string,
    requestType?: string,
): IFormEntityData => ({
    data: {
        ...data,
    } || {},
    id: data?.id || '-1',
    commentId: requestCommentId,
    topicRequestType: requestData?.requests?.topicRequestType,
    requestAddressesType: requestType !== ERequestTypeCode.MESSAGE
        ? ERequestTypeCode.REQUEST
        : ERequestTypeCode?.COMMENT_REQUEST,
    responseAddressesType: ERequestTypeCode.RESPONSE,
    commentAddressesType: ERequestTypeCode.COMMENT_REQUEST,
}) as unknown as IFormEntityData;
